import {useCallback, useEffect, useState} from 'react';
import {get} from 'lodash';

import {getDateUtilDefaultInstance} from '/util/date.util';

export const useMaintenancePageProvider = ({maintenance}: any) => {
  const [isMaintenance, setIsMaintenance] = useState();
  const [shouldUpdate, setShouldUpdate] = useState(true);

  const startMaintenanceDate = get(
    maintenance,
    'page.startMaintenanceDate',
    '',
  );
  const endMaintenanceDate = get(maintenance, 'page.endMaintenanceDate', '');

  useEffect(() => {
    if (shouldUpdate) {
      // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
      setIsMaintenance(checkForMaintenance());
      setShouldUpdate(false);
    }
    // @ts-expect-error TS(2448): Block-scoped variable 'checkForMaintenance' used b... Remove this comment to see the full error message
  }, [checkForMaintenance, shouldUpdate]);

  const checkForMaintenance = useCallback(() => {
    let isWithinRange = false;
    try {
      isWithinRange = getDateUtilDefaultInstance().isDateWithinRange(
        startMaintenanceDate,
        endMaintenanceDate,
      );
      return isWithinRange;
    } catch (err) {
      // if the date is not valid, nothing should be displayed.
      return false;
    }
  }, [startMaintenanceDate, endMaintenanceDate]);

  const updateMaintenance = () => {
    setShouldUpdate(true);
  };

  return {isMaintenance, updateMaintenance};
};
